import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const getIdentityVerificationRequirementName = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined
): string => {
  return requirement.name || "Identity verification";
};
